import { Dispatch } from "react";
import { Box, Typography } from "@mui/material";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import { findError } from "@/Settings/helpers/AdministrationTools/LocationDealerCodes/utils";
import { IArea, IPayloadArea, TAction, EActionType, TErrors } from "@/Settings/types/administrationTools/locationDealerCodes";

type AreaColumnInputProps = {
	area?: IArea;
	areas: IPayloadArea[];
	dispatch: Dispatch<TAction>;
	oemIndex: number;
	franchiseIndex: number;
	errors: TErrors;
	depth: number;
	updateFranchiseWarning: boolean;
	isPending: boolean;
};

const AreaColumnInput = ({
	area,
	areas,
	dispatch,
	oemIndex,
	franchiseIndex,
	errors,
	depth,
	updateFranchiseWarning,
	isPending,
}: AreaColumnInputProps) => {
	const handleChangeArea = (selected: IPayloadArea) => {
		dispatch({
			type: EActionType.UPDATE_AREA,
			payload: {
				oemIndex,
				franchiseIndex,
				area: selected,
			},
		});
	};
	return (
		<Box className="mr-[12px] pb-[8px]">
			<Typography className={"regular-montserrat-label pb-[4px] text-center"} style={{ fontFamily: "PTSansProNarrow" }}>
				{area?.areaLabel}
			</Typography>
			<SmartSelector
				classes="!w-[220px]"
				showBy="areaValue"
				sortBy="areaValue"
				selectBy="areaValue"
				options={areas}
				selected={area?.areaValue}
				inputProps={{
					placeholder: `Select ${area?.areaLabel}`,
				}}
				listBoxProps={{
					sx: { maxHeight: "220px" },
				}}
				warning={updateFranchiseWarning}
				error={
					!!findError(errors, [
						oemIndex,
						"franchises",
						franchiseIndex,
						...Array.from({ length: depth }, (_, i) => i + 1).map(() => "area"),
						"areaValue",
					])
				}
				onChangeAction={(selected) => handleChangeArea(selected as IPayloadArea)}
				disabled={isPending}
			/>
		</Box>
	);
};

export default AreaColumnInput;
